import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { SwiperComponent } from 'swiper/angular';
// import Swiper core and required modules
import SwiperCore, { Swiper, Virtual } from 'swiper';

// install Swiper modules
SwiperCore.use([Virtual]);

@Component({
  selector: 'app-client-login',
  templateUrl: './client-login.page.html',
  styleUrls: ['./client-login.page.scss'],
})
export class ClientLoginPage implements AfterViewInit {
  @ViewChild('swiper', { static: false }) swiper?: SwiperComponent;
  constructor() {}

  ngAfterViewInit(): void {
    this.swiper.swiperRef.disable();
  }
  forgotPw(): void {
  }

}
